import type { RestoreAccount } from '@repo/api-gw-sdk';

import type { RestoreGenericStorageProps } from '@/components/restore/restoreGenericStorageProps';

import type { BackupVaultPreferences } from '../vaults/backupVaultPreferences';

export enum PreferencesKey {
  BackupVault = 'backup-vaults',
  CurrentProject = 'current-project',
  RestoreBucket = 'restore-bucket',
  RestoreGcsBucket = 'restore-gcs-bucket',
  RestoreStorageAccount = 'restore-storage-account',
  QueryTarget = 'query-target',
  Preferences = 'ui-preferences',
}

export interface PreferencesMap {
  [PreferencesKey.BackupVault]: BackupVaultPreferences;
  [PreferencesKey.CurrentProject]: { projectId: string };
  [PreferencesKey.RestoreBucket]: { bucketName: string };
  [PreferencesKey.RestoreGcsBucket]: { bucketName: string };
  [PreferencesKey.RestoreStorageAccount]: {
    accountName: string;
    container: string;
    resourceGroup: string;
  };
  [PreferencesKey.QueryTarget]: Record<
    string,
    {
      account: RestoreAccount;
      bucket: RestoreGenericStorageProps;
    }
  >;
  [PreferencesKey.Preferences]: {
    theme?: 'dark' | 'light';
    isDevMode?: boolean;
    tables?: Record<string, { columnVisibility?: Record<string, boolean> }>;
  };
}
